import { Injector } from "@angular/core";
import { Art57NodeList } from "../../Art57Node/Art57NodeList";
import { ListView } from "../../../Data/ListView";
import { ServiceEnum } from "../../../ServiceEnum";
import { MedicinalproductsService } from "../../../../service/medicinalproducts-service/medicinalproducts.service";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { environment } from "../../../../../../environments/environment";
import { Art57Node } from "../../Art57Node/Art57Node";


export class AutoUploadList extends Art57NodeList {

    entityClass?: new (...args: any[]) => Art57Node;
    headers!: string[];
    service?: string;
    isLoaded: boolean = false;
    dataSource?: any;
    criteria: any;
    autoUploadEntityName?: string;
    disableAutoUpload: boolean = false;
    cloningNode: boolean = false;

    constructor(injector: Injector,
        labelTemplate: string,
        headers: string[],
        service: string,
        criteria: string,
        entityClass: new (...args: any[]) => any,
        autoUploadEntityName: string,
        disableAutoUpload: boolean,
        cloningNode: boolean,
        items?: any[] | undefined,
    ) {
        super(injector, new ListView(), labelTemplate);

        this.headers = headers;
        this.service = service;
        this.criteria = criteria;
        this.autoUploadEntityName = autoUploadEntityName;
        this.disableAutoUpload = disableAutoUpload;
        this.cloningNode = cloningNode;
        this.entityClass = entityClass;

        if (items){
            this.postLoad(items);
        }

    }

    override getHeaders(): string[] {
        return this.headers;
    }

    filterResult(model:any): any{
        return model;
    }


    postLoad(model: any[]) {

    }

    load() {
        let service: any;
        switch (this.service) {
            case ServiceEnum.MedicinalProducts:
                service = this.ioc!.get(MedicinalproductsService);
                break;
        }

        if (this.isLoaded) {
            return;
        }

        if (this.disableAutoUpload) {
            this.children?.splice(0, this.children.length); // remove dummy node
            this.data = new this.entityClass!(this.ioc!, this.data.model, this.labelTemplate);
            if (!this.cloningNode){
                this.postLoad(this.dataSource);
            }
            this.isLoaded = true;
        } else {        
            this.children?.splice(0, this.children.length); // remove dummy node
            service.getAll(this,this.autoUploadEntityName, this.criteria)
                .subscribe({
                    next: (data: any) => {
                        const jsonData = data.result;
                        const filteredData = this.filterResult(data.result);
                        if (filteredData) {
                            this.dataSource = jsonData;
                            this.postLoad(filteredData);
                            this.isLoaded = true;
                        } else {
                            this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'warn', detail: 'No results found', life: environment.warningElapsedTime });
                        }
                    },
                    error: (error: any) => {
                        this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'error', detail: 'Error found', life: environment.errorElapsedTime });
                    }
                });
        }
    }

}